/* Simple scroll-snap slider for hp-* sections.
   Markup: <hp-slider> containing [data-slider-track], [data-slider-prev], [data-slider-next], [data-slider-arrows]. */
if (!customElements.get('hp-slider')) {
  customElements.define(
    'hp-slider',
    class HpSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-slider-track]');
        this.prev = this.querySelector('[data-slider-prev]');
        this.next = this.querySelector('[data-slider-next]');
        this.arrows = this.querySelector('[data-slider-arrows]');
        if (!this.track) return;

        this.prev?.addEventListener('click', () => this.go(-1));
        this.next?.addEventListener('click', () => this.go(1));
        this.track.addEventListener('scroll', () => this.update(), { passive: true });
        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.track);
        this.update();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }

      go(direction) {
        // Move by exactly one "page" of fully visible cards, landing on a card edge.
        const first = this.track.firstElementChild;
        if (!first) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const step = first.getBoundingClientRect().width + gap;
        const perPage = Math.max(1, Math.round((this.track.clientWidth + gap) / step));
        const currentIndex = Math.round(this.track.scrollLeft / step);
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        const target = Math.min(maxScroll, Math.max(0, (currentIndex + direction * perPage) * step));
        this.track.scrollTo({ left: target, behavior: 'smooth' });
        // Refresh arrow states even if the browser skips scroll events (e.g. background tabs).
        clearTimeout(this.refreshTimer);
        this.refreshTimer = setTimeout(() => this.update(), 500);
      }

      update() {
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        const scrollable = maxScroll > 2;
        if (this.arrows) this.arrows.hidden = !scrollable;
        if (!scrollable) return;
        if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
        if (this.next) this.next.disabled = this.track.scrollLeft >= maxScroll - 2;
      }
    }
  );
}
